import { screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import { cssSpacing } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var LegalContainer = styled.div.withConfig({
  displayName: "LegalContainer",
  componentId: "sc-k8tc6g-0"
})(["flex:1;@media (max-width:", "){flex-basis:100%;margin-block:", " ", ";}@media (min-width:", "){margin-block:calc(-1 * ", ");}", ";"], screenXsMax, cssSpacing('tighter', '12px'), cssSpacing('looser', '20px'), screenSmMin, cssSpacing('tighter-4', '4px'), function (props) {
  return props.$legalStrict && css(["flex-basis:100%;@media (min-width:", "){margin-block-end:", ";}"], screenSmMin, cssSpacing('base', '16px'));
});